const view = require('./memberRegistrationView')
const addressSearch = require('./addressSearch')
const expandingCheckbox = require('./expandingCheckbox')
const pwnedPasswordValidator = require('./password-checking/pwnedPasswordsValidator')
const haveIBeenPwned = require('./password-checking/haveIBeenPwned')

const onRegistrationDetailsSubmitted = async event => {
    event.preventDefault()

    const siteKeyEl = document.getElementById("site-key");
    if (siteKeyEl) {
        const siteKey = siteKeyEl.value;

        let action = 'REGISTRATION';
        if (document.getElementById('member-employee-number')) {
            action = 'COLLEAGUE_REGISTRATION';
        }

        document.getElementById("reCaptchaAction").value = action;
        document.getElementById("reCaptchaToken").value =
            await window.grecaptcha.enterprise.execute(siteKey, {action: action});
    }

    view.isFormDataValid()
        .done(() => {
            view.addSpinnerForRegisterButton()
            view.disableMemberButton()
            view.submitForm(event)
        })
        .fail(() => {
            addressSearch.switchToManualAddressEntry()
            view.removeSpinnerForRegisterButton()
            view.enableMemberButton()
        })
}

const initialize = () => {
    pwnedPasswordValidator.init(haveIBeenPwned)
    view.onRegisterButtonClicked(onRegistrationDetailsSubmitted)
    expandingCheckbox.initialize()
}

module.exports = {
    initialize,
    onRegistrationDetailsSubmitted
}
